import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Divider, Typography } from '@mui/material';


function TabComponent({ tabComponent, tabTitle }) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const renderTabContent = () => {
        return tabComponent[value] || null;
    };

    return (
        <div >
            <Box
                sx={{
                    //   display:"flex",
                    //   justifyContent:"center"
                    backgroundColor: "white",
                    borderRadius: "10px"

                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable auto tabs example"
                    // sx={{ '.MuiButtonBase-root-MuiTab-root.Mui-selected ': { color: "#C38F51" } }}
                    TabIndicatorProps={{ style: { display: "none" } }}
                >
                    {tabTitle.map(
                        (label, index) => (
                            <Tab
                                key={label}
                                label={label}

                                sx={{
                                    fontSize: "17px",
                                    // display: "flex",
                                    background: "white",
                                    // justifyContent: "center",
                                    // alignItems: "center",
                                    borderRadius: "18px",
                                    margin: "10px",
                                    p: "5px 15px", // Reduced padding for the tab
                                    color: value === index ? 'white' : '##28a8e0',
                                    textTransform: 'none',
                                    fontWeight: value === index ? 'normal' : 'normal',
                                    // height: "25px", // Reduced height for the tab
                                    minWidth: 0, // Ensures no minimum width to reduce space
                                    // margin: "0 10px", // Adds spacing between tabs
                                    border: '1px solid #ddd',
                                    '&.Mui-selected': {
                                        color: 'white',
                                        background: "#28a8e0",
                                    },
                                    '&.MuiTab-root': {
                                        // minHeight: "0px",
                                        fontWeight: 700, // Use a numeric value instead of "bold"

                                    },
                                    // '&:hover': {
                                    //     color: '#F9BF10', // Hover effect for unselected tabs
                                    // },
                                }}
                            />
                        )
                    )}
                </Tabs>
            </Box>

            <Box sx={{
                py: 2, backgroundColor: "white",
                borderRadius: "10px",
                mt: 3,
                p: 2
            }}>
                <Typography variant='h6' sx={{
                    fontSize:"22px",
                    mb:2
                }} >Notifications</Typography>
                <Divider />
                <Box sx={{
                    border:"1px solid #ddd",
                    borderRadius:"10px",
                    p: 2,
                    mt:3
                }}>{renderTabContent()}</Box>
            </Box>

        </div >
    );
}

export default TabComponent;

